/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function ReviewerChangesRequested({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="var(--current-background, var(--neutral-1))" stroke="var(--current-background, var(--neutral-1))" strokeLinejoin="round" strokeWidth={1.6} d="M7.042 1.07a1.92 1.92 0 0 1 1.916 0l4.565 2.635c.593.342.958.975.958 1.66v5.27c0 .685-.365 1.318-.958 1.66l-4.565 2.636a1.92 1.92 0 0 1-1.916 0l-4.566-2.636a1.92 1.92 0 0 1-.957-1.66v-5.27c0-.685.365-1.318.957-1.66z" /><mask id="ReviewerChangesRequested_svg__a" width={16} height={16} x={0} y={0} maskUnits="userSpaceOnUse" style={{
      maskType: "luminance"
    }}><path fill="#fff" d="M16 0H0v16h16z" /><path stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M8 5.03h1.32a1.98 1.98 0 1 1 0 3.96H4.832M6.68 7.01 4.7 8.99l1.98 1.98" /></mask><g mask="url(#ReviewerChangesRequested_svg__a)"><path fill="currentColor" d="M7.1 1.485a1.8 1.8 0 0 1 1.8 0l4.292 2.478c.557.321.9.916.9 1.56v4.955a1.8 1.8 0 0 1-.9 1.56L8.9 14.514a1.8 1.8 0 0 1-1.8 0l-4.292-2.478a1.8 1.8 0 0 1-.9-1.56V5.523a1.8 1.8 0 0 1 .9-1.56z" /></g></svg>;
}
;